import classNames from "classnames";
import { ArrowDownRightIcon, ArrowUpRightIcon } from "@vetty/icons";
import { useEffect, useState } from "react";
import type { StatisticsReportModel } from "../../_utils/statisticsReportModel.util";
import styles from "./StatisticsReportTemplate.module.scss";

type StatisticsReportTemplateProps = {
  model: StatisticsReportModel;
};

export const StatisticsReportTemplate = ({
  model,
}: StatisticsReportTemplateProps) => {
  const { periodLabel, metrics } = model;

  /** Data URL avoids html2canvas quirks with masked SVG loaded as a separate document request. */
  const [logoSrc, setLogoSrc] = useState("/assets/logo-light.svg");

  useEffect(() => {
    let cancelled = false;
    fetch("/assets/logo-light.svg")
      .then((r) => {
        if (!r.ok) throw new Error("logo fetch");
        return r.text();
      })
      .then((text) => {
        if (cancelled) return;
        setLogoSrc(
          `data:image/svg+xml;charset=utf-8,${encodeURIComponent(text)}`,
        );
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={styles["root"]} data-statistics-report-template>
      <div className={styles["root__header"]}>
        <img
          src={logoSrc}
          alt="Vetty"
          className={styles["root__header__logo"]}
          height={64}
        />

        <p className={styles["root__header__period"]}>{periodLabel}</p>
      </div>

      <div className={styles["root__grid"]}>
        {metrics.map((m) => (
          <div key={m.heading} className={styles["root__cell"]}>
            <p className={styles["root__cell__heading"]}>{m.heading}</p>
            <div className={styles["root__cell__valueRow"]}>
              <p className={styles["root__cell__value"]}>{m.value}</p>
              {m.variant !== "none" ? (
                <span
                  className={classNames(
                    styles["root__cell__delta"],
                    styles[`root__cell__delta--${m.variant}`],
                  )}
                >
                  {m.variant === "positive" ? (
                    <ArrowUpRightIcon style={{ width: 28, height: 28 }} />
                  ) : (
                    <ArrowDownRightIcon style={{ width: 28, height: 28 }} />
                  )}
                  <span>{m.deltaLabel}</span>
                </span>
              ) : (
                <span
                  className={classNames(
                    styles["root__cell__delta"],
                    styles["root__cell__delta--none"],
                  )}
                >
                  {m.deltaLabel}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
